import { Group, Image } from "@mantine/core";
import logo from "../images/Logo.png";
import React from "react";

export default function BrandLogoName() {
    return (
        <Group>
            <Image src={logo} alt="Think Cloudly Logo" width={36} height={36} fit="contain" className="h-[36px]" />
        </Group>
    );
}
